<template>
  <button v-on="$listeners"
          :class="['button',
                   {'button_full': full},
                   {'button_icon': icon},
                   {'button_icon-left': iconLeft},
                   {'button_left': iconArrowLeft},
                   {'button_small': small},
                   {'button_outline': outline},
                   {'is-disabled': disabled},
                   {'is-hide': hide},
                   {'is-loading': loading}]">
    <span class="button__content">
      <template v-if="iconArrowLeft">
           <IconArrowLeft/>
      </template>
      <template v-if="iconArrowRight">
        <IconArrowRight/>
      </template>
      <template v-if="iconArrowTop">
        <IconArrowTop class="icon_white"/>
      </template>
      <template v-if="iconArrowBottom">
        <IconArrowBottom class="icon_white"/>
      </template>
      <span v-if="$slots['default']" class="button__title">
        <slot/>
      </span>
    </span>
  </button>
</template>

<script>
import ButtonController from '@/components/buttons/button-controller'
// components
import IconArrowLeft from '@/components/icons/IconArrowLeft'
import IconArrowRight from '@/components/icons/IconArrowRight'
import IconArrowTop from '@/components/icons/IconArrowTop'
import IconArrowBottom from '@/components/icons/IconArrowBottom'

export default {
  name: 'Button',
  mixins: [ButtonController],
  components: {
    IconArrowLeft,
    IconArrowRight,
    IconArrowTop,
    IconArrowBottom
  }
}
</script>
